import { flatten } from 'array-flatten';
import parseSrcSet from 'parse-srcset';

function getUrlFromSrcSet(srcset){
    var parsed = parseSrcSet(srcset);
    let url = null;
    parsed.forEach(item => {
        if(item.d > 1){
            if(window.devicePixelRatio > 1)
                return item.url;
        }
        else url = item.url;
    });
    return url;
}

function getDomPictureUrls(domElement, selector = ""){
	let pictures = domElement.querySelectorAll(':scope picture' + selector);

	let urls = new Set();
	pictures.forEach(picture => {
		let found = false;
		let sources = picture.querySelectorAll(':scope source');
		sources.forEach(source => {
			let media = source.getAttribute('media');
			if(media != ""){
            	var mql = window.matchMedia(media);
            	if(mql.matches){
            		found = true;
            		urls.add(getUrlFromSrcSet(source.getAttribute('srcset')));
            	}
			}
		});

		if(!found){
			urls.add(getDomImageUrls(picture));
		}
	});
	return urls;
}

function getDomImageUrls(domElement, selector = ""){
	let images = domElement.querySelectorAll(':scope img' + selector);
	let urls = new Set();
	images.forEach(img => {
		if(img.srcset != "")
			return urls.add(getUrlFromSrcSet(img.src));
		urls.add(img.src);
	});
	return urls;
}

function getCssImageUrls(domElement, selector = ""){
	let divs = domElement.querySelectorAll(':scope div' + selector);
	let urls = new Set();
	divs.forEach(div => {
		let url  = window.getComputedStyle(div).backgroundImage;
		if(url.indexOf("linear-gradient") == -1 && url.indexOf("radial-gradient") == -1){
	        url = url.replace("url(\"", "").replace("url(", "").replace("\")", "").replace(")", "");
	        if(url != "none" && url.length) urls.add(url);
		}
	});
	return urls;
}


function imageUrls(domElement, selector = ""){
	return Array.from(getDomImageUrls(domElement, selector))
	.concat(Array.from(getDomPictureUrls(domElement, selector)))
	.concat(Array.from(getCssImageUrls(domElement, selector)));
}

function concatSets(set, ...iterables) {
    for (const iterable of iterables) {
        for (const item of iterable) {
            set.add(item);
        }
    }
    return set;
}

export default imageUrls;
export { imageUrls };